/**
 * Created by CCristi on 7/15/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoterInterface = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let VoterInterface = exports.VoterInterface = function (_Core$OOP$Interface) {
  _inherits(VoterInterface, _Core$OOP$Interface);

  function VoterInterface() {
    _classCallCheck(this, VoterInterface);

    return _possibleConstructorReturn(this, (VoterInterface.__proto__ || Object.getPrototypeOf(VoterInterface)).call(this, ['vote']));
  }

  /**
   * @returns {String}
   */


  _createClass(VoterInterface, null, [{
    key: 'ALLOW',
    get: function get() {
      return 'Allow';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DENY',
    get: function get() {
      return 'Deny';
    }
  }]);

  return VoterInterface;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Voter/VoterInterface.js
// module id = 181
// module chunks = 0